import { useReduxState } from 'hooks';
import { FormGroup } from 'components/common/form';
import { CheckboxInput, RadioGroupInput } from 'components/common/form/common';

interface Props {
  blockId: number;
  correctAnswerSet: boolean;
  data: {
    feedbackType?: string;
    randomizeOptions?: boolean;
    isSingleChoice?: boolean;
  };
  disabled?: boolean;
  enableRandomizer: boolean;
  onFeedbackTypeChange: (feedbackType: string) => void;
  onRandomizeOptionsChange: (value: boolean) => void;
}

const EditorBlockChoiceTasksMoreOptionsSettings = ({
  blockId,
  correctAnswerSet,
  data,
  disabled,
  enableRandomizer,
  onFeedbackTypeChange,
  onRandomizeOptionsChange
}: Props) => {
  const { messages } = useReduxState();

  const handleRandomizeOptionsChange = (ev) => {
    const value = ev.target.checked as boolean;
    onRandomizeOptionsChange(value);
  };

  return (
    <div style={{ marginTop: 15 }}>
      <FormGroup label={messages.commonFeedback}>
        <RadioGroupInput
          onChange={onFeedbackTypeChange}
          options={[
            {
              disabled,
              id: `editor-multiplechoice-feedback-type-default-${blockId}`,
              label: messages.editorBlockMultipleChoiceFeedbackTypeDefault,
              tooltip:
                messages.editorBlockMultipleChoiceFeedbackTypeDefaultDescription,
              value: 'default'
            },
            {
              disabled,
              id: `editor-multiplechoice-feedback-type-answer-specific-${blockId}`,
              label: messages.editorBlockMultipleChoiceFeedbackTypeAnswer,
              tooltip:
                messages.editorBlockMultipleChoiceFeedbackTypeAnswerDescription,
              value: 'answer-specific'
            },
            {
              disabled: disabled || !correctAnswerSet,
              id: `editor-multiplechoice-feedback-type-result-based-${blockId}`,
              label: messages.editorBlockMultipleChoiceFeedbackTypeResult,
              tooltip: data.isSingleChoice
                ? messages.editorBlockSingleChoiceFeedbackTypeResultDescription
                : messages.editorBlockMultipleChoiceFeedbackTypeResultDescription,
              value: 'result-based'
            }
          ]}
          value={data.feedbackType || 'default'}
        />
      </FormGroup>

      {enableRandomizer ? (
        <FormGroup label={messages.blocksMultipleChoiceOptions}>
          <CheckboxInput
            checked={data.randomizeOptions || false}
            disabled={disabled}
            id={`randomize-options-${blockId}`}
            label={messages.editorBlockMultipleChoiceRandomizeOptions}
            onChange={handleRandomizeOptionsChange}
            stopPropagation={true}
          />
        </FormGroup>
      ) : null}
    </div>
  );
};

export default EditorBlockChoiceTasksMoreOptionsSettings;
